// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as FilterFunctor from "../../../../library/filter-module/filter-view-template/FilterFunctor.bs.js";
import * as FilterOrderConfig from "./FilterOrderConfig.bs.js";

var OrderFilterComponent = FilterFunctor.T(FilterOrderConfig.T);

function FilterOrderComponent(Props) {
  var params = Props.params;
  return React.createElement(OrderFilterComponent.make, {
              params: params
            });
}

var make = FilterOrderComponent;

export {
  OrderFilterComponent ,
  make ,
  
}
/* OrderFilterComponent Not a pure module */
